import { useTranslation } from "react-i18next";
import TextField from "shared/components/form/TextField";
import { CreateBlackListItem } from "../../../api/types/blacklist";

const Form = () => {
  const { t } = useTranslation();

  const fieldProps = {
    mb: "20px",
    w: {
      base: "100%",
      md: "50%",
    },
  };

  return (
    <>
      <TextField<CreateBlackListItem["request"]>
        type={"number"}
        name="telegram_id"
        label="Telegram ID"
        placeholder="Enter telegram id"
        required
        {...fieldProps}
      />
    </>
  );
};

export default Form;
